<template>
  <div>
    <div class="bg">
      <!-- 顶部欢迎栏 -->
      <div class="top-bar">
        <div class="container">
          <span class="welcome">{{ currentDate }}，陵城天气：{{ realtime.text }} {{ realtime.temp }}℃ {{ realtime.wind_dir }}{{ realtime.wind_class }}</span>
          <div class="auth-links">
            <span class="link" @click="goLogin" v-if="!token">登录/注册</span>
            <span class="link" @click="goMemberCenter" v-else>会员中心</span>
          </div>
        </div>
      </div>

      <!-- 幻灯片 -->
      <div style="width: 1200px;margin: 0 auto;height: 95px;display: flex;align-items: center">
        <div style="font-size: 0">
          <img src="../assets/home/logo.png" alt="" width="260">
        </div>
        <div style="font-size: 24px;font-weight: bold;color: #0D56BD;font-style: italic;margin-left: 40px;letter-spacing: 2px">惠企助企服务&nbsp;&nbsp;精准服务直达快享</div>
      </div>
    </div>

    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="container">
        <div class="nav-item" v-for="item in navList" :key="item.path"
             :class="{ active: $route.meta.index === item.index }" @click="goNav(item.path)">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";

export default {
  name: 'PublicHeader',
  data() {
    return {
      token: '',
      // 日期
      currentDate: '',
      // 导航
      navList: [
        { name: '首页', path: '/', index: 1 },
        { name: '新闻中心', path: '/newsCenter', index: 11 },
        { name: '企业大厅', path: '/enterpriseLibrary', index: 7 },
        { name: '需求大厅', path: '/demandHall', index: 2 },
        { name: '政策中心', path: '/policyCenter', index: 4 },
        { name: '活动中心', path: '/activityCenter', index: 5 },
        { name: '贸易平台', path: '/hzPort', index: 12 },
        { name: '金融赋能', path: '/financial', index: 8 },
        { name: '租房服务', path: '/rentalService', index: 9 },
        { name: '人才供给', path: '/talentSupply', index: 10 },
      ],
      realtime: {},
    }
  },
  mounted() {
    this.token = getToken()
    this.getTQ()
    this.setCurrentDate()
  },
  methods: {
    getTQ() {
      fetch('https://gfapi.mlogcn.com/weather/v001/now?areacode=101120413&key=MnWEzUWmGFSgaDpNp3djQQdc79AfAFxp&output_type=json')
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json(); // 解析为JSON
          })
          .then(data => {
            if (data.status === 0) {
              this.realtime = data.result.realtime;
            }
          })
          .catch(error => console.error('There was a problem with the fetch operation:', error));
    },
    setCurrentDate() {
      const now = new Date();
      const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
      this.currentDate = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日 星期${weekDays[now.getDay()]}`;
    },
    goNav(path) {
      if (this.$route.path !== path) this.$router.push(path);
    },
    goLogin() {
      this.$router.push('/loginRegister')
    },
    goMemberCenter() {
      // this.$router.push('/userProfile')
      window.open('/userProfile')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bg {
  background: url(../assets/home/banner.png) no-repeat center; height: 160px;
}

.top-bar { color: #0D56BD; line-height: 34px;
  .container { display: flex; justify-content: space-between; align-items: center; width: 1200px; margin: 0 auto; height: 50px }
  .welcome { color: #0D56BD; }
  .auth-links { display: flex; gap: 16px;
    .link { cursor: pointer; color: #ffffff; background: linear-gradient(to right, #4787e8, #0D56BD); border-radius: 10px; padding: 0 12px;
      &:hover { font-weight: bold }
    }
  }
}

.nav-bar { background: #0D56BD;
  .container { display: flex; justify-content: center; width: 1200px; margin: 0 auto }
  .nav-item { flex: 1; text-align: center; line-height: 60px; color: #fff; font-size: 18px; cursor: pointer; transition: background 0.2s;
    &:hover, &.active { background: #01419C; }
  }
}
</style>
